var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_20083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.28291 14.7693H3.79363C3.22704 14.7693 2.76904 15.2004 2.76904 15.7337V23.0356C2.76904 23.569 3.22704 24.0001 3.79363 24.0001H7.28291C7.84951 24.0001 8.3075 23.569 8.3075 23.0356V15.7381C8.3075 15.2048 7.84951 14.7693 7.28291 14.7693Z",
    fill: "#B0ADE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85357 23.0356V15.7337C3.85357 15.2004 4.19402 14.7693 4.6152 14.7693H3.53067C3.10949 14.7693 2.76904 15.2004 2.76904 15.7337V23.0356C2.76904 23.569 3.10949 24.0001 3.53067 24.0001H4.6152C4.19402 24.0001 3.85357 23.569 3.85357 23.0356Z",
    fill: "#A09CDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6676 11.0769H11.1784C10.6118 11.0769 10.1538 11.5199 10.1538 12.0678V23.0091C10.1538 23.557 10.6118 24 11.1784 24H14.6676C15.2342 24 15.6922 23.557 15.6922 23.0091V12.0678C15.697 11.5199 15.2342 11.0769 14.6676 11.0769Z",
    fill: "#FD6F71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7806 23.0136V12.0678C11.7806 11.5199 12.2913 11.0769 12.923 11.0769H11.2962C10.6645 11.0769 10.1538 11.5199 10.1538 12.0678V23.009C10.1538 23.557 10.6645 23.9999 11.2962 23.9999H12.923C12.2965 24.0045 11.7806 23.5616 11.7806 23.0136Z",
    fill: "#E34B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0524 7.38464H18.5632C17.9966 7.38464 17.5386 7.83433 17.5386 8.39065V22.994C17.5386 23.5503 17.9966 24 18.5632 24H22.0524C22.619 24 23.077 23.5503 23.077 22.994V8.39065C23.0817 7.83897 22.619 7.38464 22.0524 7.38464Z",
    fill: "#57D0E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1654 22.994V8.39065C19.1654 7.83433 19.676 7.38464 20.3078 7.38464H18.681C18.0493 7.38464 17.5386 7.83433 17.5386 8.39065V22.994C17.5386 23.5503 18.0493 24 18.681 24H20.3078C19.6813 24 19.1654 23.5503 19.1654 22.994Z",
    fill: "#4DB8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4144 0.00441015L19.8159 0.442791L20.6842 1.53197L17.6018 3.69223L15.981 2.35449C15.7061 2.12401 15.296 2.11045 15.0018 2.31834L8.10387 7.14505L6.49274 6.0152C6.21779 5.82087 5.83671 5.82087 5.56176 6.0152L0 9.9064L0.93098 11.0769L6.02001 7.51112L7.63114 8.64097C7.90609 8.8353 8.28717 8.8353 8.56212 8.64097L15.4263 3.84137L17.0471 5.17911C17.322 5.4096 17.732 5.42316 18.0263 5.21527L21.6151 2.70249L22.4882 3.79618L23.9546 0.686838C24.1186 0.334326 23.8148 -0.0453032 23.4144 0.00441015Z",
    fill: "#58B78C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_20083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.3dc097456df15d47da6ccd136faa5247.svg";
export { ForwardRef as ReactComponent };